import { Data, TransformsList } from 'cio/utils/analytics/transforms';

const Transforms: TransformsList = {
  switchToPremiumClicked({ data }) {
    let analyticsData: Record<string, any> = {
      'Account Id': data.account_id,
      'Feature Name': data.feature_name,
      Requester: data.requester,
      'Requester Email': data.requester_email,
      'Requester User Id': data.requester_user_id,
    };

    return analyticsData;
  },
  essentialsPostCheckoutViewed({ data }) {
    let analyticsData: Record<string, any> = {
      'Account Id': data.account_id,
      Requester: data.requester,
      'Requester Email': data.requester_email,
      'Requester User Id': data.requester_user_id,
    };
    return analyticsData;
  },
  premiumPostCheckoutViewed({ data }) {
    let analyticsData: Record<string, any> = {
      'Account Id': data.account_id,
      Requester: data.requester,
      'Requester Email': data.requester_email,
      'Requester User Id': data.requester_user_id,
    };
    return analyticsData;
  },
  includedInPlanViewed({ data }) {
    let analyticsData: Record<string, any> = {
      'Account Id': data.account_id,
      Requester: data.requester,
      'Requester Email': data.requester_email,
      'Requester User Id': data.requester_user_id,
    };
    return analyticsData;
  },
  viewAllFeaturesClicked({ data }) {
    let analyticsData: Record<string, any> = {
      'Account Id': data.account_id,
      Requester: data.requester,
      'Requester Email': data.requester_email,
      'Requester User Id': data.requester_user_id,
      'Current Plan': data.current_plan,
      'Viewed Feature List': data.viewed_feature_list,
    };
    return analyticsData;
  },
  salesOrContractsLetsTalkClicked(data: Data & { type: string }) {
    return {
      'Button Name': {
        essentials: 'essentials ',
        premium: 'premium',
        enterprise: 'enterprise',
        startup: 'startup',
        compare_plans: 'compare plans',
      }[data.type],
    };
  },
  buyOrRequestAccessClicked({ data }) {
    return {
      'Account Id': data.account_id,
      'Current Plan': data.current_plan,
      'Requested Plan': data.requested_plan,
      Text: data.text,
    };
  },
  planActionClicked({ data }) {
    return {
      'Account Id': data.account_id,
      'Current Plan': data.current_plan,
      Action: data.action,
    };
  },
  yourPlanAvailablePlanCtaClicked({ data }) {
    return {
      'Account Id': data.account_id,
      'Current Plan': data.current_plan,
      Action: data.action,
      'Available Plan': data.available_plan,
    };
  },
  limitsBannerLearnMoreClicked({ data }) {
    return {
      'Account Id': data.account_id,
      'Current Plan': data.current_plan,
      'Banner Id': data.banner_id,
    };
  },
  startJourneysTrialClicked({ data }) {
    return {
      'Account Id': data.account_id,
      'Current Plan': data.current_plan,
    };
  },
  viewBillingHelp({ data }) {
    return {
      'Account Id': data.account_id,
      'Current Plan': data.current_plan,
    };
  },
  availablePlansSectionChanged({ data }) {
    return {
      'Next Section': data.next_section,
    };
  },
  startCdpStarterSubscriptionClicked({ data }) {
    return {
      'Account Id': data.account_id,
    };
  },
};

export default Transforms;
